const accordion = () => {
  $('.js-accordion-title').click(function(){
    $(this).parent().toggleClass('active');
  });
}

export default accordion;